import { readCookie } from '@/utils/cookie';

export const CONSENT_COOKIE = 'cookieconsent_status';

/**
 * Whether the visitor has agreed to non-essential cookies.
 *
 * Undecided counts as no: the banner is still up, and silence is not agreement.
 *
 * @returns {boolean}
 */
export const hasAnalyticsConsent = () => readCookie(CONSENT_COOKIE) === '1';

/**
 * Gate the tracking service's events on consent.
 *
 * an2.js already waits (see integrations/s3.client.js) and the GTM container
 * now does too, so this was the one dispatcher still sending regardless.
 *
 * trackEvent is replaced on the instance itself rather than on a wrapper. A
 * wrapper delegating through the prototype would rebind `this` for every other
 * method to the wrapper instead of the service, which breaks the moment anyone
 * calls one. This way the service is returned unchanged apart from the one
 * method being guarded.
 *
 * @param {object} service the TrackingService instance to guard, mutated in place
 * @returns {object} that same service
 */
export function withAnalyticsConsent(service) {
  const send = service.trackEvent.bind(service);

  service.trackEvent = (...args) => (hasAnalyticsConsent() ? send(...args) : undefined);

  return service;
}
